<template>
  <div class="window schedule-window add-schedule-window" v-show="isVisible">
    <alert-window ref="alertWindow"></alert-window>
    <span class="close" title="Закрыть" @click="$emit('close-window', false)"><img src="../image/cancel.svg"></span>
    <div class="head-block">
      <div class="window-title">Задать расписание</div>
    </div>
    <div class="workers-block">
      <div class="name">
        <span class="icon"><i class="fa fa-user-o"></i></span>
        {{ [worker.surname, worker.name, worker.patronymic].join(" ") }} <span
        class="dop-info">{{ worker.type }}, {{ getWorkerCategories(worker) }}</span>
      </div>
    </div>
    <div class="form">
      <template v-if="showPeriods" v-for="(period, index) in scheduleList">
        <schedule-period-for-day
          :arrayIndex="index"
          :day="today"
          :propPeriod="period"
          :periodIsVisible="periodIsVisible"
          :prepareToSave="prepareToSaveFlag"
          :workerId="worker.id"
          @newPeriod="receivePeriods"
          @valid="checkValid"
          @removePeriod="removePeriod"
        ></schedule-period-for-day>
      </template>
      <div class="add-schedule-string visibility">
        <div class="add-schedule-block" @click="addPeriod"><span class="icon">+</span>Добавить период</div>
      </div>
      <div class="buttons">
        <button type="button" class="save-button" @click="prepareToSaveFlag = true">Сохранить</button>
      </div>
    </div>
  </div>
</template>

<script>
  import SchedulePeriodForDay from '@/views/SchedulePeriodForDay.vue'
  import {ru} from '@codeanker/vuejs-datepicker/dist/locale'
  import {mask} from 'vue-the-mask'
  import moment from 'moment'
  import api from '@/api'
  import AlertWindow from '@/components/AlertWindow.vue'

  export default {
  name: 'DailySchedule',
  props: ['isVisible', 'worker', 'day', 'schedule'],
  components: {
    SchedulePeriodForDay,
    AlertWindow
  },

  directives: { mask },

  data () {
    return {
      datepickerLanguageRu: ru,
      time: {},
      today: {},
      scheduleList: [],
      prepareToSaveFlag: false,
      periodIsVisible: false,
      newPeriodsList: [],
        receivedPeriodsCount: 0,
        showPeriods: true
    }
  },

  watch: {
    isVisible (val) {
      this.periodIsVisible = val
      if (val) {
        this.scheduleList = Object.assign([], this.$store.getters.dailyScheduleListForWorker)
        this.today = this.day
      } else {
        this.scheduleList = []
        this.prepareToSaveFlag = false
        this.newPeriodsList = []
        this.receivedPeriodsCount = 0
      }
    },
    receivedPeriodsCount (val) {
      if (val = this.scheduleList.length) {
        this.save()
      }
    }
  },

  methods: {
    getWorkerCategories (worker) {
      return worker.categories ? worker.categories.join(', ') : ''
    },

    save () {
      window.setTimeout(() => {
        let list = this.$store.getters.newDailyScheduleListForWorker.slice(0)
        let oldList = this.$store.getters.dailyScheduleListForWorker.slice(0)
        let firstDayOfNightShift = {}
        oldList.forEach((period) => {
          if (!period.wsc_holiday && !period.wsc_weekend && !period.wsc_worker_hill &&
              period.wsc_start_work_time !== '00:00' && period.wsc_end_work_time === '23:59') {
            firstDayOfNightShift = Object.assign({}, period)
          }
        })
        let promises = []
        if (firstDayOfNightShift) {
          list.forEach((period) => {
            if (!period.wsc_holiday && !period.wsc_weekend && !period.wsc_worker_hill &&
                period.wsc_id === firstDayOfNightShift.wsc_id && period.wsc_end_work_time !== '23:59') {
              let nextDayShift = null;
              promises.push(
                api.getAllWorkersSchedule(moment(period.wsc_date).add(1, 'day').format('x'),
                  moment(period.wsc_date).add(1, 'day').format('x')).then((shifts) => {
                  shifts.forEach((s) => {
                    if (s.id === period.wkr_worker_id.id) {
                      let schedule = s.scheduleMap[moment(period.wsc_date).add(1, 'day').format('YYYY-MM-DD')]
                      for (let i = 0; i < schedule.length; i++) {
                        if (schedule[i].wkr_worker_id.id === period.wkr_worker_id.id && !schedule[i].wsc_holiday &&
                            !schedule[i].wsc_weekend && !schedule[i].wsc_worker_hill &&
                            schedule[i].wsc_start_work_time === '00:00' && schedule[i].wsc_end_work_time !== '23:59') {
                          nextDayShift = Object.assign({}, schedule[i])
                          break
                        }
                      }
                    }
                  })
                }).then(() => {
                  if (!!nextDayShift) {
                    let timeFrom = nextDayShift.wsc_start_work_time.split(':')
                    let timeTo = nextDayShift.wsc_end_work_time.split(':')
                    api.deleteWorkerSchedule(period.wkr_worker_id.id,
                      moment(nextDayShift.wsc_date).hour(Number(timeFrom[0])).minute(Number(timeFrom[1])).second(0).format('x'),
                      moment(nextDayShift.wsc_date).hour(Number(timeTo[0])).minute(Number(timeTo[1])).second(0).format('x'),
                      true
                    )
                  }
                }))
            }
          })
        }

        Promise.all(promises).then(() => {
          let workShiftListForThisDay = []
          for (let i = 0; i < list.length; i++) {
            let period = list[i]
            if (!period.wsc_holiday && !period.wsc_weekend && !period.wsc_worker_hill) { workShiftListForThisDay.push(period) }
          }
          list.forEach(period => {
            period.wkr_worker_id = this.worker.id
          })
          api.setWorkerSchedule(list)
            .then(() => {
              this.$emit('close-window', false)
            })
            .catch((e) => {
              console.log(e)
            })
          this.$store.commit('clearNewDailyScheduleListForWorker')
        })
      }, 500)
    },
    addPeriod () {
      let newPeriod = {
        'wsc_id': 0,
        'wkr_worker_id': this.worker.id,
        'wsc_date': null,
        'wsc_start_work_time': null,
        'wsc_end_work_time': null,
        'wsc_holiday': false,
        'wsc_weekend': false,
        'wsc_worker_hill': false
      }
      this.scheduleList.push(Object.assign({}, newPeriod))
    },
    receivePeriods () {
      this.receivedPeriodsCount++
    },
    removePeriod (schedule) {
      if (!schedule.isNew) {
        api.deleteWorkerSchedule(schedule.workerId, schedule.dateFrom, schedule.dateTo, true)
          .then(() => {
            this.scheduleList.splice(schedule.id, 1)

              // ререндер компонента
              this.showPeriods = false;
              this.$nextTick().then(() => {
                  this.showPeriods = true;
              });

            if (!this.scheduleList || this.scheduleList.length == 0) { this.$emit('close-window', false) }
          })
          .catch(response =>
            this.$refs.alertWindow.show('Уведомление', response, false)
          )
      } else { this.scheduleList.splice(schedule.id, 1) }
    },
    checkValid (isValid) {
      if (!isValid) {
        this.prepareToSaveFlag = false
      }
    }
  }
}
</script>
